import { durationBetween, formatDate } from "@/util/date"
import dayjs from "dayjs"
import { formatCurrency, formatWholeCurrency } from "@/util/currency"
import { providerName } from "@/util/provider"

export default {
    install(Vue) {
        Vue.filter("currency", formatCurrency)
        Vue.filter("currencyWhole", formatWholeCurrency)
        Vue.filter("date", formatDate)
        Vue.filter("days", days)
        Vue.filter("durationBetween", durationBetween)
        Vue.filter("digitsLast4", digitsLast4)
        Vue.filter("providerName", providerName)
    },
}

function days(start, end = Date.now()) {
    let djsStart = dayjs(start).startOf("day")
    let djsEnd = dayjs(end).startOf("day")
    return Math.round(durationBetween(djsStart, djsEnd).asDays())
}

function digitsLast4(value) {
    if (!value || value.length < 4) return value
    return value.substring(value.length - 4, value.length)
}
